<template>
  <v-container
    id="conformidade-obras-historico"
    fluid
    tag="section"
  >
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-file-check-outline"
          inline
          class="ml-0 px-5 py-4"
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Conformidade de Obras
            </div>
          </template>

          <v-btn
            color="success"
            dark
            elevation="1"
            class="mt-5"
            style="float:left"
            relative
            text
            medium
            @click="$router.push({ name: 'Conformidade de Obras Edit' })"
          >
            <v-icon
              left
              size="30px"
            >
              mdi-plus-circle
            </v-icon>
            Criar Teste
          </v-btn>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="break-search ml-auto mt-4"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px;"
          />

          <general-progress-bars
            class="mt-11"
            :items="downloadProgressData"
            prefix-text="Baixando resultado do teste"
          />

          <v-divider class="mt-10" />

          <v-data-table
            :headers="headers"
            :items="itemsFormatados"
            :search.sync="search"
            :header-props="{ sortByText: 'Ordenar Por' }"
            :footer-props="{ itemsPerPageText: 'Itens por Página' }"
            no-data-text="Nenhum teste disponível"
            no-results-text="Nenhum registro correspondente encontrado"
            :loading="loading"
            mobile-breakpoint="900"
          >
            <template v-slot:[`item.nome`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="text-truncate-column"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ item.nome }}
                  </div>
                </template>
                <span>{{ item.nome }}</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <general-status :status="item.status" />
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                :disabled="item.status !== 'SUCESSO'"
                :class="item.status !== 'SUCESSO' ? 'cursor-block' : ''"
                min-width="0"
                class="px-1"
                fab
                icon
                x-small
                :loading="downloadProgressData[item.id] !== undefined"
                @click="downloadItem(item)"
              >
                <v-icon small>
                  mdi-download
                </v-icon>
              </v-btn>

              <v-menu
                v-if="item.status === 'SUCESSO' || canRunItem(item) || canDeleteItem(item)"
                offset-y
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="white"
                    class="ml-1"
                    height="22px"
                    width="22px"
                    fab
                    x-small
                    elevation="1"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-if="canRunItem(item)"
                    @click="executar(item.id)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-play
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Executar
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="canDeleteItem(item)"
                    @click="openDeleteDialog(item)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-trash-can-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Excluir
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="openDialogDetalhes(item)"
                  >
                    <v-list-item-icon class="mx-0 my-0 py-4">
                      <v-icon small>
                        mdi-file-find-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Detalhes
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:[`footer`]>
              <v-switch
                v-if="$store.getters.userIsAdmin"
                class="pa-0 pl-2 swithInterna"
                style="position: absolute;"
                color="primary"
                label="Exibir Expirados"
                dense
                @change="processamentosExpirados = $event; getAll()"
              />
            </template>

            <template v-slot:[`footer.page-text`]>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="getAll()"
                  >
                    mdi-refresh
                  </v-icon>
                </template>
                <span>Clique aqui para recarregar o histórico</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </base-material-card>

        <dialog-delete
          :show-dialog="dialogDelete"
          @changeValue="dialogDelete = $event"
          @deleteTriggered="deletar(dialogDeleteData.id)"
        >
          <template slot="title">
            Excluir teste #{{ dialogDeleteData.id }}
          </template>
          <template slot="body">
            Tem certeza que deseja excluir <strong>{{ dialogDeleteData.nome }}</strong>?
          </template>
        </dialog-delete>
      </v-col>
    </v-row>

    <general-dialog-detalhes
      title="Detalhes do teste"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        />
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>

<script>
import dayjs from 'dayjs';
import ConformidadeObrasService from '@/services/ConformidadeObrasService';
import pusherMixins from '@/mixins/pusherMixins';

export default {
  name: 'ConformidadeObrasHistorico',

  components: {
    DialogDelete: () => import('@/components/general/DialogDelete'),
    GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
    GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
    GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
  },

  mixins: [pusherMixins],

  data() {
    return {
      items: [],
      loading: false,
      processamentosExpirados: false,
      search: '',
      downloadProgressData: {},
      dialogDelete: false,
      dialogDeleteData: {},
      dialogDetalhes: false,
      dialogDetalhesData: [],
      dialogDetalhesHeader: [
        { text: 'Resumo', value: 'parametro', sortable: false },
        { text: 'Valor', value: 'valor', sortable: false }
      ],
      headers: [
        { text: '#', value: 'id' },
        { text: 'Nome', value: 'nome' },
        { text: 'Teste', value: 'teste_nome' },
        { text: 'Usuário', value: 'usuario_nome' },
        { text: 'Processado em', value: 'processado_em_formatado' },
        { text: 'Arquivos', value: 'qtd_arquivos' },
        { text: 'Registros', value: 'qtd_inventarios' },
        { text: 'Alertas', value: 'qtd_duplicados' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'actions', sortable: false, align: 'right' }
      ]
    };
  },

  computed: {
    itemsFormatados() {
      return (this.items || []).map((item) => {
        return {
          ...item,
          usuario_nome: item.usuario ? item.usuario.nome : '',
          processado_em_formatado: item.processado_em ? dayjs(item.processado_em).format('DD/MM/YYYY HH:mm') : ''
        };
      });
    }
  },

  mounted() {
    this.getAll();
    this.subscribe();
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('refreshConformidadeObras', () => {
        this.getAll();
      });
    },

    getAll() {
      this.loading = true;

      ConformidadeObrasService.getExecucoes(this.processamentosExpirados)
        .then((response) => {
          this.items = response.data.data || [];
        })
        .catch((error) => {
          this.$toast.error('Erro ao recuperar histórico da Conformidade de Obras.', '', { position: 'topRight' });
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    canRunItem(item) {
      return item.status !== 'EXECUTANDO' && item.status !== 'AGUARDANDO';
    },

    canDeleteItem(item) {
      const user = this.$store.getters.getUser;
      const userIsAdmin = this.$store.getters.userIsAdmin;
      return item.status !== 'EXECUTANDO' && (userIsAdmin || user.id_hexa === item.usuario_id);
    },

    downloadItem(item) {
      this.$set(this.downloadProgressData, item.id, { id: item.id });
      this.$toast.info('Preparando seu arquivo para download.', '', { position: 'topRight', timeout: 2000 });

      ConformidadeObrasService.download(item.id, {
        timeout: 60 * 60 * 1000,
        onDownloadProgress: (progressEvent) => {
          const progress = progressEvent.total
            ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
            : 0;

          this.$set(this.downloadProgressData, item.id, {
            id: item.id,
            progress,
            isComputable: progressEvent.lengthComputable
          });
        }
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `resultado_conformidade_obras_${item.id}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.$toast.error('Falha no download do resultado.', '', { position: 'topRight' });
          console.error(error);
        })
        .finally(() => {
          this.$delete(this.downloadProgressData, item.id);
        });
    },

    executar(id) {
      ConformidadeObrasService.executar(id)
        .then(() => {
          this.$toast.info('O teste foi reagendado e será processado em instantes.', '', { position: 'topRight', timeout: 2000 });
          this.getAll();
        })
        .catch((error) => {
          const message = error?.response?.data?.erro || 'Erro ao reagendar o teste.';
          this.$toast.error(message, '', { position: 'topRight' });
          console.error(error);
        });
    },

    openDeleteDialog(item) {
      this.dialogDeleteData = {
        id: item.id,
        nome: item.nome
      };
      this.dialogDelete = true;
    },

    deletar(id) {
      ConformidadeObrasService.deletar(id)
        .then(() => {
          this.$toast.success('Teste excluído com sucesso.', '', { position: 'topRight' });
          this.dialogDelete = false;
          this.getAll();
        })
        .catch((error) => {
          const message = error?.response?.data?.erro || 'Erro ao excluir o teste.';
          this.$toast.error(message, '', { position: 'topRight' });
          console.error(error);
        });
    },

    openDialogDetalhes(item) {
      const resumo = item.resumo_array || {};
      const arquivos = resumo.arquivos || [];
      const parametros = item.parametros_execucao_array || {};

      this.dialogDetalhesData = [
        { parametro: 'Teste', valor: item.teste_nome || '-' },
        { parametro: 'Status', valor: item.status || '-' },
        { parametro: 'Data blindada', valor: resumo.data_blindada || item.data_blindada || '-' },
        { parametro: 'Versão blindada', valor: resumo.versao_blindada || parametros.versao_blindada || '-' },
        { parametro: 'Data incremental', valor: resumo.data_incremental || item.data_incremental || '-' },
        { parametro: 'Versão incremental', valor: resumo.versao_incremental || parametros.versao_incremental || '-' },
        { parametro: 'Data lançamento', valor: resumo.data_lancamento || parametros.data_lancamento || '-' },
        { parametro: 'Data unitização', valor: resumo.data_unitizacao || parametros.data_unitizacao || '-' },
        { parametro: 'Inventário unitização', valor: parametros.inventario_unitizacao || '-' },
        { parametro: 'UP unitização', valor: parametros.up_unitizacao || '-' },
        { parametro: 'Qtd. arquivos', valor: item.qtd_arquivos },
        { parametro: 'Qtd. registros analisados', valor: resumo.qtd_registros_analisados || item.qtd_inventarios },
        { parametro: 'Qtd. alertas', valor: resumo.qtd_alertas || item.qtd_duplicados },
        { parametro: 'Arquivos', valor: arquivos.length ? arquivos.join(', ') : '-' }
      ];

      if (resumo.erro) {
        this.dialogDetalhesData.push({
          parametro: 'Erro',
          valor: resumo.erro
        });
      }

      this.dialogDetalhes = true;
    }
  }
};
</script>
